const accessInventory = {

    STOCK_LIST: { name: 'Stock', path: '/stock-list' },
    ADD_STOCK: { name: 'Add Stock', path: '/create-stock' },
    STOCK_AVAILABILITY: { name: 'Stock Availability', path: '/stock-availability' },

}

export default accessInventory;